import bowser from 'yola-bowser';
import { isElementNode, isTag, removeSetOfNodes } from 'anodum';
import isTextNodeWithSpacingOnly from '../verifiers/is-text-node-with-spacing-only';
import isEmptyEditableElement from '../verifiers/is-empty-editable-element';

const cleanBreakElements = (element) => {
  const breakElements = [...element.querySelectorAll('br')];
  const nodesToRemove = [];

  breakElements.forEach((br) => {
    if (bowser.firefox && br.hasAttribute('type')) {
      nodesToRemove.push(br);
    }

    let lastNode = br.parentElement;

    if (isEmptyEditableElement(lastNode)) return;

    while (lastNode.lastChild) {
      lastNode = lastNode.lastChild;

      if (isTextNodeWithSpacingOnly(lastNode)) {
        if (lastNode.previousSibling && !isTextNodeWithSpacingOnly(lastNode.previousSibling)) {
          lastNode = lastNode.previousSibling;
        }

        while (lastNode.previousSibling && isTextNodeWithSpacingOnly(lastNode.previousSibling)) {
          lastNode = lastNode.previousSibling;
        }
      }
    }

    if (lastNode !== br) return;

    if (br.previousSibling && isElementNode(br.previousSibling) && isTag(br.previousSibling, 'br'))
      return;

    nodesToRemove.push(br);
  });

  removeSetOfNodes(nodesToRemove);
};

export default cleanBreakElements;
